"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationProgress = exports.TEST_ID_OPERATIONAL_PROGRESS = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var react_1 = require("react");
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
exports.TEST_ID_OPERATIONAL_PROGRESS = "operation-progress-button";
function OperationProgress(_a) {
    var heading = _a.heading, progress = _a.progress, progressString = _a.progressString, ctaText = _a.ctaText, ctaAction = _a.ctaAction;
    var nullBreaks = [null, null, null, null];
    return (theme_ui_1.jsx(react_1.Fragment, null,
        theme_ui_1.jsx(theme_ui_1.Heading, { sx: {
                mt: 0,
                textAlign: "center"
            }, as: "h3", variant: "text.h3" }, heading),
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: { alignItems: "center", height: 6, justifyContent: "center", mt: 1 } },
            progress < 100 &&
                theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                        flexFlow: "column",
                        alignItems: "center",
                        width: "100%",
                    } },
                    theme_ui_1.jsx(__1.Progress, { csx: {
                            maxWidth: "200px",
                            mt: 5,
                            mx: "auto",
                            width: "100%"
                        }, max: 100, value: progress }),
                    theme_ui_1.jsx(theme_ui_1.Text, { sx: { mt: 4 } }, progressString)),
            progress === 100 &&
                theme_ui_1.jsx(__1.Button, { "data-testid": exports.TEST_ID_OPERATIONAL_PROGRESS, csx: {
                        borderRadius: __spreadArrays(nullBreaks, [null, 3]),
                        fontSize: __spreadArrays(nullBreaks, [null, 3]),
                        mt: 5,
                        py: __spreadArrays(nullBreaks, [null, 3]),
                        px: __spreadArrays(nullBreaks, [null, 4])
                    }, onClick: ctaAction }, ctaText))));
}
exports.OperationProgress = OperationProgress;
